import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Экологический туризм (экотуризм)';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p className="sub">Посещение мест с относительно нетронутой природой и хорошо сохранившимся
                        культурно-историческим наследием.</p>
                    <p>Призван обеспечивать общение с природой и способствовать усилению интереса туристов к
                        природоохранным
                        мероприятиям. Программы экологического туризма предусматривают посещение национальных и других
                        парков, заповедников, экологически чистых мест и т. д. В процессе подобных туров проводятся
                        семинары
                        по экологии, встречи с общественностью и другие мероприятия.</p>
                    <p>По утверждению Питера Шэклфорда, регионального представителя ВТО в Европе, термин «экотуризм»
                        используется в индустрии туризма уже более 10 лет, однако в это понятие вкладывается разное
                        содержание. В одном случае экотуризм - это путешествия, предпринимаемые в нетронутые
                        человеческой
                        цивилизацией, экологически чистые уголки природы для поддержания экологического равновесия в
                        природе. В другом - термин «экотуризм» рассматривается как ярлык предлагаемого к продаже
                        турпродукта.</p>
                    <p>Путешествия, совершаемые в рамках экологического тура, достаточно разнообразны - от небольших
                        познавательных туров для школьников, до регулярных туристических программ в национальных парках
                        Исследования показали, основным мотивом участия в экологических турах является желание
                        насладиться
                        первозданной природой.</p>
                    <div className="two-col-cell">
                        <ul>
                            <li><a href='http://brestobl.com/priroda/lb/1.htm'><img src={require('./../img/lb.gif')}/> Лебедь-шипун</a></li>
                            <li><Link to="/vtur-bel-puscha"><img src={require('./../img/bp.gif')}/> Беловежская пуща</Link></li>
                            <li><Link to="/vtur-mulnoie-ozero"><img src={require('./../img/mul.gif')}/> Озеро Мульное</Link></li>
                            <li><a href='http://brestobl.com/turizm/marsh/1.html'><img src={require('./../img/pusca.gif')}/> По пути в Беловежскую пущу</a></li>
                            <li><a href='http://brestobl.com/priroda/poles/index.html'><img src={require('./../img/poles.gif')}/> Полесье</a></li>
                        </ul>
                    </div>
                </div>

                <div className="pageitem">
                    <p>
                        <blockquote>В Брестской области наиболее перспективными для развития экотуризма являются ГНП
                            «Беловежская
                            пуща», Ружанская пуща, Пино-Припятская пойма, заказники республиканского значения, оз.
                            Выгонощанское.
                            Основные направления развития: создание экологических троп с оборудованием туристских
                            стоянок;
                            организация туристских походов по лесным, водным, болотным экосистемам; подготовка
                            экологически
                            образованных кадров работников туристских предприятий; организация специализированных туров
                            для
                            иностранных туристов с фотоохотой;
                        </blockquote>
                    </p>
                </div>
            </div>
        </>
    );
}